import React, { useState } from 'react';
import './LandingText.css';
import { TypeAnimation } from 'react-type-animation';
import ThemeToggle from './ThemeToggle';

const LandingText = ({ isScrolled, theme, toggleTheme }) => {
  const [showSecondLine, setShowSecondLine] = useState(false);

  return (
    <div
      className={`landing-text ${isScrolled ? 'scrolled' : ''}`}
    >
      {isScrolled ? (
        <div className="scrolled-content">
          <h1>Ramtin Nouri - Software Engineer</h1>
          <ThemeToggle theme={theme} toggleTheme={toggleTheme} />
        </div>
      ) : (
        <>
          <TypeAnimation
            sequence={[
              'Hi, my name is Ramtin Nouri.',
              1000,
              () => setShowSecondLine(true),
            ]}
            wrapper="h1"
            cursor={false}
            repeat={0}
            style={{ fontSize: '2em', display: 'block' }}
          />
          {showSecondLine && (
            <TypeAnimation
              sequence={['Software Engineer.', 2000]}
              wrapper="p"
              cursor
              repeat={0}
              style={{ fontSize: '1.5em', display: 'block' }}
            />
          )}
        </>
      )}
    </div>
  );
};

export default LandingText;